import React, { useState, useEffect } from "react";
import auction from "../assets/img/auction.png";
import Footer from "../components/footer/Footer";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import Profile from "../assets/img/profile.png";
import { fontFamily } from "@material-ui/system";
// import "bootstrap/dist/css/bootstrap.min.css";
import Modal from "react-modal";
import { useHistory, useLocation } from "react-router";
import axios from "axios";
import ReactAudioPlayer from "react-audio-player";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

export default function NftDetails(props) {
  // let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [loading, setLoading] = useState(true);
  const [type, setType] = useState("");
  const [data, setData] = useState("");
  const location = useLocation();

  useEffect(() => {
    // console.log(location.state.type);
    setType("direct");
    // setLoading(false);
    const tokenId = window.location.href.split("/").pop();

    axios({
      method: "POST",
      url: "https://loud-final.herokuapp.com/get_token_info",
      data: {
        tokenId: tokenId,
      },
    })
      .then((res) => {
        console.log(res.data.nft, "this is nft info");
        setData(res.data.nft);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        alert("some error occurred!");
      });
  }, []);

  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100vw",
      paddingTop: "100px",
    },
  };

  function openModal() {
    setIsOpen(true);
  }

  // function afterOpenModal() {
  //   // references are now sync'd and can be accessed.
  //   subtitle.style.color = "#f00";
  // }

  function closeModal() {
    setIsOpen(false);
  }
  const classes = useStyles();
  return (
    <div>
      {loading ? (
        <div style={{ marginTop: "100px" }}>
          <center>Loading</center>{" "}
        </div>
      ) : (
        <div className="nftdetails-wrapper">
          <div
            className="price"
            style={{ marginTop: "-14px", fontSize: "12px" }}
          >
            <div>
              <div style={{ marginBottom: "4px" }}> 1 Music = $USD 0.452</div>
              <div> 1 BNB = $USD 0.452 </div>
            </div>
          </div>
          <Modal
            isOpen={modalIsOpen}
            // onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            className="react-modal-self"
            style={customStyles}
            contentLabel="Example Modal"
          >
            <div className="placebid-modal-body">
              <div className="placebid-modal-head">
                <div> </div>
                <div>{type === "bid" ? "Place Bid" : "CHECKOUT"}</div>
                <div className="modal-custom-close" onClick={closeModal}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    class="bi bi-x-circle"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </div>
              </div>
              {type === "bid" ? (
                <>
                  <div className="modal-body-price">
                    <div>Price</div>
                    <div>Subtotal</div>
                  </div>
                  <div className="modal-body-info">
                    <div
                      style={{
                        flex: "0.7",
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                        borderTopLeftRadius: "10px",
                        borderBottomLeftRadius: "10px",
                      }}
                    >
                      Music
                    </div>
                    <div
                      style={{
                        flex: "0.6",
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      0.1
                    </div>
                    <div
                      style={{
                        flex: "0.8",
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ paddingTop: "4px", paddingRight: "4px" }}>
                        $
                      </span>
                      9.999
                    </div>
                  </div>
                </>
              ) : (
                <div className="modal-buy-wrapper">
                  <div className="modal-buy-header">
                    <div>Item</div>
                    <div>Subtotal</div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "10px",
                      paddingBottom: "16px",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "50%",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <img
                          src={auction}
                          alt="no"
                          style={{ width: "60px", marginRight: "20px" }}
                        />
                      </div>

                      <div style={{ fontSize: "12px" }}>{data.description}</div>
                    </div>
                    <div>
                      15 MUSIC <br /> <span>($987.00)</span>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "20px",
                    }}
                  >
                    <div>Total</div>
                    <div>
                      15 MUSIC <br /> <span>($987.00)</span>
                    </div>
                  </div>
                </div>
              )}

              <div className="modal-condition">
                <input style={{ width: "40px" }} type="checkbox" />
                <div>
                  By checking this box, I agree to Musette’s{" "}
                  <a href="/terms" style={{ color: "orange" }}>
                    Terms of Service
                  </a>
                </div>
              </div>

              <div className="modal-buttons">
                <div className="modal-placebid">
                  {type === "bid" ? "Place Bid" : "Checkout"}
                </div>
                <div className="modal-convertmusic">
                  {type === "bid" ? "Convert MUSIC" : "Add Funds"}
                </div>
              </div>
            </div>
          </Modal>
          <div className="nftdetails-contain">
            <div className="nftdetails-left">
              <div className="nft-card">
                <div className="nft-card-title">{data.name}</div>
                <div className="nft-card-image">
                  <img
                    src={data.cover_image}
                    alt="no"
                    className="nft-card-image-class"
                    style={{ width: "80%" }}
                  />
                </div>
                <div className="nft-likes">
                  <svg
                    style={{ marginRight: "6px" }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="#CFC7C4"
                    class="bi bi-suit-heart-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z" />
                  </svg>
                  0
                </div>
                <ReactAudioPlayer
                  src={data.music}
                  style={{
                    width: "90%",
                    marginTop: "10px",
                    marginLeft: "14px",
                  }}
                  autoPlay
                  controls
                />
                <div className="nft-description">{data.description}</div>
                <div className="nft-buttons">
                  <div>Indie</div>
                  <div>Pop</div>
                  <div>r&B</div>
                </div>
              </div>
              <div className="share"></div>
            </div>
            <div className="nftdetails-right">
              <div className="nft-info">
                <div className="nft-info-head">
                  <div className="owner" style={{ marginRight: "20px" }}>
                    <Avatar
                      alt="Remy Sharp"
                      src={Profile}
                      className={classes.medium}
                      style={{ cursor: "pointer", marginRight: "8px" }}
                    />
                    <div>
                      <div style={{ marginBottom: "6px" }}>Owner</div>
                      <div>{data.owned_by.slice(0, 6) + "..."}</div>
                    </div>
                  </div>
                  <div className="artist">
                    <Avatar
                      alt="Remy Sharp"
                      src={Profile}
                      className={classes.medium}
                      style={{ cursor: "pointer", marginRight: "8px" }}
                    />
                    <div>
                      <div style={{ marginBottom: "6px" }}>Creator</div>
                      <div>{data.created_by.slice(0, 6) + "..."}</div>
                    </div>
                  </div>
                </div>
                <div className="nft-info-details">
                  <div>
                    <div className="nftinfo-tab">NFT Token ID</div>
                    <div>{data.token_id}</div>
                  </div>
                  <div>
                    <div>Selling Method</div>
                    <div>Instant</div>
                  </div>
                  <div>
                    <div>Number of Nfts</div>
                    <div>1</div>
                  </div>
                  <div>
                    <div>Minimum Bid price</div>
                    <div>NIL</div>
                  </div>
                  <div>
                    <div>Royalties</div>
                    <div>10%</div>
                  </div>
                </div>
                <center>
                  {/* <div className="time">02D 48H 07M 3S left</div> */}
                  <div className="placebid" onClick={openModal}>
                    {type === "bid" ? "Place Bid" : "Buy"}
                  </div>
                </center>
              </div>
              <div className="nft-history">
                <div>History</div>

                <div className="history-container">
                  <div style={{ display: "flex", fontSize: "14px" }}>
                    <Avatar
                      alt="Remy Sharp"
                      src={Profile}
                      className={classes.medium}
                      style={{ cursor: "pointer", marginRight: "8px" }}
                    />
                    <div style={{ marginRight: "12px" }}>
                      <div style={{ paddingBottom: "4px" }}>
                        Token Minted{" "}
                        <span
                          style={{
                            fontWeight: "bolder",
                            color: "#574C4F",
                            fontFamily: "sans-serif",
                          }}
                        >
                          {" "}
                          5.5 Music
                        </span>
                      </div>
                      <div>
                        By{" "}
                        <span
                          style={{
                            fontWeight: "bolder",
                            color: "#574C4F",
                            fontFamily: "sans-serif",
                          }}
                        >
                          {" "}
                          {data.created_by.slice(0, 6) + "..."}
                        </span>{" "}
                        Few minutes ago
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      )}
    </div>
  );
}
